<template>
  <div class="fases-indicator">
    <span class="title-fases">Phase</span>
    <div class="content-fases">
      <div class="btn-slide" @click="moveCarousel(-1)" :disabled="atHeadOfList">
        <font-awesome-icon icon="caret-left" />
      </div>
      <div class="carrousel">
        <div
          class="cards"
          :style="{
            transform: 'translateX' + '(' + currentOffset + 'px' + ')',
          }"
        >
          <div
            class="item-fase"
            :class="step.active ? 'activate' : ''"
            :style="step.id === getPhaseSelected.id ? 'font-weight:bold;' : ''"
            v-for="(step, index) in Phases"
            :key="index"
          >
            <div
              class="item-indicator"
              :class="step.complete ? 'complete' : ''"
            >
              <div
                class="btn-fase"
                data-v-step="7"
                @click="btnPhase(step.id)"
                :style="
                  step.id === getPhaseSelected.id ? 'background:#9dcdfb;' : ''
                "
              >
                {{ step.complete ? "" : index + 1 }}
                <font-awesome-icon v-if="step.complete" icon="check" />
              </div>
              <hr v-if="index != Phases.length - 1" />
            </div>
            <span
              :style="
                step.id === getPhaseSelected.id ? 'font-weight:bold ;' : ''
              "
              >{{ step.name }}</span
            >
          </div>
        </div>
      </div>

      <div class="btn-slide" @click="moveCarousel(1)" :disabled="atEndOfList">
        <font-awesome-icon icon="caret-right" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";

export default {
  data: () => ({
    currentOffset: 0,
    windowSize: 5,
    paginationFactor: 243,
  }),
  computed: {
    ...mapState(["Phases"]),
    ...mapGetters(["getPhaseSelected"]),
    atEndOfList() {
      return (
        this.currentOffset <=
        this.paginationFactor * -1 * (this.Phases.length - this.windowSize)
      );
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    },
  },
  methods: {
    ...mapMutations(["setPhaseSelected"]),
    btnPhase(id) {
      if (this.getPhaseSelected.id !== id) {
        this.setPhaseSelected(id);
      }
    },
    refactorWindow() {
      const spaceSize = document.getElementsByClassName("carrousel")[0]
        .offsetWidth;

      this.windowSize = Math.trunc(spaceSize / this.paginationFactor) + 1;
    },
    moveCarousel(direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
  },
  mounted() {
    this.refactorWindow(true);
    window.addEventListener("resize", this.refactorWindow);
  },
  destroyed() {
    window.removeEventListener("resize", this.refactorWindow);
  },
};
</script>

<style scoped>
.content-fases {
  display: flex;
  align-items: center;
  widows: 100%;
}

.fases-indicator {
  font-family: "Montserrat", sans-serif;
  margin-bottom: 10px;
}
.title-fases {
  font-size: 0.8rem;
  color: var(--fifth-color);
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
}
.content-fases {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 100%;
}
.carrousel {
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
  width: 100%;
}
.carrousel .cards {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 150ms ease-out;
  transform: translatex(0px);
  padding: 10px 0;
}

.item-fase {
  display: flex;
  flex-direction: column;
  margin-left: 15px;
}
.item-fase span {
  margin-top: 5px;
  font-weight: 400;
  text-align: left;
  color: var(--fifth-color);
  font-size: 0.8rem;
}
.item-fase .item-indicator {
  display: flex;
  align-items: center;
}
.item-fase .item-indicator .btn-fase {
  border: 1px solid var(--fifth-color);
  color: var(--fifth-color);
  width: 30px;
  height: 30px;
  border-radius: 100%;
  background: none;
  font-size: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.item-fase .item-indicator hr {
  width: 180px;
  height: 1px;
  margin: 0 5px;
  background: #76777a;
  border: none;
}

.item-fase .item-indicator.complete .btn-fase {
  background: var(--third-color);
  border: none;
  color: #000;
}

.item-fase .item-indicator.complete hr {
  background: var(--seventh-color);
}

.item-fase.activate .item-indicator .btn-fase {
  background: var(--sixth-color);
  border: none;
  color: #000;
  cursor: pointer;
}
.item-fase .item-indicator .btn-fase:hover {
  transform: scale(1.1);
  transition: 0.5s;
}
</style>
